/* eslint-disable */
/**
 * AUTO-GENERATED FILE.
 * Do not edit manually.
 *
 * Source:
 * 02-src/02-client/dashboard-pages/*.json
 *
 * Generated by:
 * 01-build/08-build-dashboard-pages.js
 */

const dashboardPages = [
  {
    "route": "/home/",
    "pageType": "Home",
    "events": [
      {
        "name": "login.start.top-nav",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorites.click.view.top-nav",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "cart.view.top-nav",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.directMatch",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "contentResultsClick.predictive",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "currency.change.top-nav",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.attempt",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.start",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "seeOffer.click",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "menu.click",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "registration.start",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "shopNewReleases.click",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "see_products.related_monograph",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "see_products.related_subscriptions",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "view_uspnf.related_monograph",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "quickOrder.start",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      }
    ]
  },
  {
    "route": "/product/",
    "pageType": "PDP",
    "events": [
      {
        "name": "page-view.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "document.download.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.info_sheet",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.material_origin",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      }
    ]
  },
  {
    "route": "/products/",
    "pageType": "PDP",
    "events": [
      {
        "name": "page-view.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "document.download.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.info_sheet",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.material_origin",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      }
    ]
  },
  {
    "route": "/store/product/",
    "pageType": "PDP",
    "events": [
      {
        "name": "page-view.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "document.download.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.coming_soon",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.pdp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.info_sheet",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "lots.material_origin",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "add-to-cart.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind_me.see_products",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      }
    ]
  },
  {
    "route": "/cateory/",
    "pageType": "PLP",
    "events": [
      {
        "name": "add-to-cart.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "contentResultsClick.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "filterOptionChange.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind-me.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "searchResults.manual",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "documentDownload.directMatch",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.results.manual",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.results.predictive",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "searchResults.directMatch",
        "pass": 0,
        "fail": 0
      }
    ]
  },
  {
    "route": "/search/",
    "pageType": "PLP",
    "events": [
      {
        "name": "add-to-cart.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "favorite.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "contentResultsClick.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "filterOptionChange.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "remind-me.plp",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "searchResults.manual",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "link.click",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "documentDownload.directMatch",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.results.manual",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "search.results.predictive",
        "pass": 0,
        "fail": 0
      },
      {
        "name": "searchResults.directMatch",
        "pass": 0,
        "fail": 0
      }
    ]
  }
];

export default dashboardPages;
